import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminService } from "../services/admin.service";
import { ProvisionOrgRequest } from "../domain/types/admin.types";

export function useProvisionOrganisation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (req: ProvisionOrgRequest) => adminService.provisionOrganisation(req),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-orgs"] });
    },
  });
}
